import { Button } from "components/Form";
import React from "react";
import "./Quantity.scss";
export function Decrement({ decrement }) {
    return (React.createElement(Button, { type: "button", onClick: decrement, buttonName: "-", className: "k-quantity--decrease decrement" }));
}
